(function() {
    const AggiuntaDispositivoService = function(
        $http,
        CONSTANTS,
        generalSrvc,
        labelSrvc
    ) {
        this.aggiungi = (codiceUtente, idUtente, idCredenziale, nome, otp1, otp2) => {
            const params = {
                codiceUtente: codiceUtente,
                idUtente: idUtente,
                idCredenziale: idCredenziale.replace(/\s/g, ''),
                nome: nome.trim(),
                otp1: otp1,
                otp2: otp2
            };
            return $http({
                method: 'POST',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.VIP.AGGIUNGI,
                data: params
            });
        };

        this.disabilita = (codiceUtente, idCredenziale) => {
            const params = {
                codiceUtente: codiceUtente,
                idUtente: null,
                idCredenziale: idCredenziale,
                nome: null,
                otp1: null,
                otp2: null
            };
            return $http({
                method: 'POST',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.VIP.DISABILITA,
                data: params
            });
        };
    };

    AggiuntaDispositivoService.$inject = [
        '$http',
        'Mitom_CONSTANTS',
        'MitomGenralSrvc',
        'MitomLabelSrvc'
    ];

    angular
        .module('cbl.mitomanager.wa')
        .service('MitomAggiuntaDispositivoService', AggiuntaDispositivoService);
})();